import { Link, useParams } from "react-router-dom";

import styled from "styled-components/macro";

const RedirectStyles = styled.div`
  padding: 2em;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  div {
    padding: 0.5em;
  }
`;

const OldTilesPageMatched = () => {
  const { ckey, group, detail } = useParams();
  const redirectLink = `/${ckey}/dashboard${group ? "/" + group : ""}${
    detail ? "/" + detail : ""
  }`;
  return (
    <RedirectStyles>
      <div>Flight has updated its address!</div>
      <div>Please use the following link instead:</div>
      <div>
        <Link to={redirectLink}>https://flight.raven.ai{redirectLink}</Link>
      </div>
    </RedirectStyles>
  );
};

export default OldTilesPageMatched;
